export const submissionStatuses = {
  NEW: 'new',
  DECLINED: 'declined',
  DECLINED_CONDITION: 'declined_condition',
  DECLINED_BRAND: 'declined_brand',
  DECLINED_AUTHENTICITY: 'declined_authenticity',
};
